// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"431":"1db35391","838":"c49e36b2","874":"cd6cd1d5"}[chunkId] + ".chunk.css";
};